import 'breakpoints-js/dist/breakpoints.min';

//https://github.com/amazingSurge/breakpoints-js
const breakpoints = {
    init() {
        Breakpoints({
            mobile:  {
                min: 1,
                max: 767
            },
            tablet:  {
                min: 768,
                max: 1151
            },
            desktop: {
                min: 1152,
                max: Infinity
            }
        });
    }
};

$(() => {
    breakpoints.init();
});
